import { useEffect } from 'react'

/**
 * Returns the keyboard shortcut label for Ctrl+N (Cmd+N on Mac).
 * Use for tooltips on Add buttons that support this shortcut.
 */
export function getCtrlNShortcutLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl+N'
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
  return isMac ? 'Cmd+N' : 'Ctrl+N'
}

function isInputFocused(): boolean {
  if (typeof document === 'undefined') return false
  const el = document.activeElement
  if (!el) return false
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) return true
  if (el.getAttribute?.('contenteditable') === 'true') return true
  return false
}

/**
 * Registers Ctrl+N (Cmd+N on Mac) to call onOpen. Does not fire when focus
 * is in an input, textarea, or contenteditable. Use on list pages to open
 * the main "Add" dialog.
 */
export function useCtrlN(onOpen: () => void): void {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
        if (isInputFocused()) return
        e.preventDefault()
        onOpen()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onOpen])
}
